import { useCallback, useState } from 'react';
import { FirebaseAuthenticationClient } from '@framework/firebase/auth';

const hasGoogleProvider = (): boolean =>
  FirebaseAuthenticationClient.getProviderData()?.some((provider) => provider?.providerId === 'google.com') ?? false;

type Result = {
  googleLinked: boolean;
  refreshGoogleLinked: () => Promise<void>;
};

/**
 * ログイン中ユーザーの Google アカウント連携状態を Firebase Auth の providerData から返すフック。
 * refreshGoogleLinked は Firebase Auth サーバーから最新状態を再読込して providerData を確実に反映する
 * (連携/解除の後に呼び出す)。
 */
export const useGoogleLinked = (): Result => {
  const [googleLinked, setGoogleLinked] = useState(hasGoogleProvider);

  const refreshGoogleLinked = useCallback(async () => {
    await FirebaseAuthenticationClient.reloadCurrentUser();
    setGoogleLinked(hasGoogleProvider());
  }, []);

  return { googleLinked, refreshGoogleLinked };
};
